
export default {

  /** 导出类型-1.预览 */
  EXPORT_TYPE_VIEW: 'VIEW',
  /** 导出类型-2.PDF下载 */
  EXPORT_TYPE_PDF: 'PDF',
  /** 导出类型-3.Word下载 */
  EXPORT_TYPE_WORD: 'WORD',
  /** 导出类型-4.Excel下载 */
  EXPORT_TYPE_EXCEL: 'EXCEL',
  /** 导出类型-5.打印 */
  EXPORT_TYPE_PRINT: 'PRINT',

  /**
   * 直接打印
   */
  getReport: function (vm, exportType, reportName, url, extraParams, iframe, exportName) {
    // 导出文件名：默认使用报表名
    exportName = exportName || reportName
    // 参数
    var params = {jasperExportType: exportType, jasperReportName: reportName, jasperExportName: exportName}
    var urlWithSymbol = url.indexOf('?') > 0 ? url + '&' : url + '?'
    iframe.src = urlWithSymbol + vm.$baize.toQueryString(params) + '&' + vm.$baize.toQueryString(extraParams)

    if (exportType === this.EXPORT_TYPE_PRINT) {
      iframe.onload = function () {
        iframe.contentWindow.print()
        iframe.onload = null
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/baize/src/JasperHandler.js